import {FETCH_SOCIAL_REQUEST, FETCH_SOCIAL_SUCCES, FETCH_SOCIAL_ERROR} from '../constants/Social'
import { jsonGet, errorHandler } from '../utils/Request';

const loadSocial = () => (dispatch) => {
  const apiUrl = '/config/social/';
  dispatch({
    type: FETCH_SOCIAL_REQUEST,
  });
  return jsonGet(apiUrl)
    .then(json => {
      dispatch({
        type: FETCH_SOCIAL_SUCCES,
        payload: json,
      });
    })
    .catch((e) => {
      dispatch({
        type: FETCH_SOCIAL_ERROR
      });
      errorHandler(e);
    });
};

export { loadSocial };



// WEBPACK FOOTER //
// ./src/actions/SocialActions.js